"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let JobSchedulerConfig = class JobSchedulerConfig extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resource;
    async $$load_resource() {
        return this.oid
            ? this.$fn.fetch('read_job_scheduler_config', { parameters: { id: this.oid }, asResource: true })
            : this.$fn.schemaDefaults('CreateMethodSchedulerConfig');
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    kwargs;
    async $$load_kwargs() {
        return this.editor.kwargs ? JSON.stringify(this.editor.kwargs, null, 2) : null;
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    ux;
    b_7315092382398562_modalBindings;
    b_7756430993412511_options;
    dataMembers = ['resource', 'editor', 'kwargs', 'formId', 'formName', 'ux', 'b_7315092382398562_modalBindings', 'b_7756430993412511_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resource: null,
                editor: null,
                kwargs: null,
                formId: null,
                formName: "JobSchedulerConfig",
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_7756430993412511_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                    extraKeys: {
                        "Ctrl-Q": "toggleComment",
                    },
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("JobSchedulerConfig|Title", "Job scheduler configuration"),
                ],
                icon: this.$config.settings.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5334_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_5340_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_5338_getActionArgs($event) {
        return {
            objectType: "job_scheduler_config",
            op: "upsert",
            data: {
                ...this.editor.getData(),
                kwargs: this.kwargs ? JSON.parse(this.kwargs) : null,
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_5344_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1548630417156826_request_5342_getActionArgs($event) {
        return {
            operation: "delete_job_scheduler_config",
            data: this.resource.getData({ fields: ['id', 'etag'] }),
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_5346_getActionArgs($event) {
        return {
            name: this.modalName,
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5334 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5334_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5333 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5334,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5333],
        });
        const act_2248226175642056_closeComponent_5336 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5335 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5336,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5335],
        });
        const act_1040167445267876_closeModal_5340 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_5340_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5339 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_5340,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_5338 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_5338_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_5339],
        });
        const evh_1040167445267876_submit_5337 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_5338,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5337],
        });
        const act_1548630417156826_closeModal_5344 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_5344_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_5343 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_5344,
            event: "success",
            displayName: "closeModal",
        });
        const act_1548630417156826_request_5342 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_5342_getActionArgs,
            displayName: "delete",
            events: [evh_1548630417156826_success_5343],
        });
        const evh_1548630417156826_clickPreventStop_5341 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_5342,
            event: "click.prevent.stop",
            displayName: "delete",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_5341],
        });
        const act_2186679009640457_closeModal_5346 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_5346_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_5345 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_5346,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_5345],
        });
        return {
            act_7315092382398562_closeModal_5334,
            evh_7315092382398562_close_5333,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5336,
            evh_2248226175642056_close_5335,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_5340,
            evh_1040167445267876_success_5339,
            act_1040167445267876_crud_5338,
            evh_1040167445267876_submit_5337,
            evh_1040167445267876_submit,
            act_1548630417156826_closeModal_5344,
            evh_1548630417156826_success_5343,
            act_1548630417156826_request_5342,
            evh_1548630417156826_clickPreventStop_5341,
            evh_1548630417156826_clickPreventStop,
            act_2186679009640457_closeModal_5346,
            evh_2186679009640457_clickPreventStop_5345,
            evh_2186679009640457_clickPreventStop,
            save: act_1040167445267876_crud_5338,
            delete: act_1548630417156826_request_5342,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], JobSchedulerConfig.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobSchedulerConfig.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], JobSchedulerConfig.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], JobSchedulerConfig.prototype, "onSize", null);
JobSchedulerConfig = __decorate([
    (0, vue_property_decorator_1.Component)()
], JobSchedulerConfig);
exports.default = JobSchedulerConfig;
vue_property_decorator_1.Vue.component("JobSchedulerConfig", JobSchedulerConfig);
